import {
  Checkbox,
  FormControl,
  Input,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { menuItemStyles } from "MUITheme";
import React, { useEffect, useState } from "react";

function MultiSelectDropdown({
  options,
  labelText,
  mandetory,
  onSelectChange,
  styleProp,
}) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, // Controls dropdown height
      },
    },
  };

  const MenuItemProps = {};

  const [fieldValue, setFieldValues] = useState([]);
  const allOptionIds = options.map((option) => option.id);
  const isAllSelected = fieldValue.length === allOptionIds.length;

  useEffect(() => {
    setFieldValues([]);
  }, [options]);

  const handleChange = (e) => {
    const { value } = e.target;

    console.log("value", value);

    if (value.includes("all")) {
      // If "Select All" is checked, select all items; otherwise, clear all
      const newSelected = isAllSelected ? [] : allOptionIds;
      setFieldValues(newSelected);
      onSelectChange(newSelected);
      console.log(newSelected);
    } else {
      // Handle individual selections
      const updatedValues =
        typeof value === "string" && value.length > 0
          ? value.split(",")
          : value;
      setFieldValues(updatedValues);
      onSelectChange(updatedValues);
      console.log(updatedValues);
    }
  };

  return (
    <FormControl sx={styleProp}>
      <label>
        {labelText}
        {mandetory ? <span style={{ color: "red" }}>*</span> : ""}
      </label>
      <Select
        labelId="multiple-checkbox-label"
        id="multiple-checkbox"
        multiple
        value={fieldValue}
        onChange={handleChange}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
        renderValue={(selected) =>
          selected.length === 0 ? (
            <em style={{ color: "gray" }}>{labelText}</em>
          ) : isAllSelected ? (
            `All (${selected.length}) Selected`
          ) : (
            selected
              .map((id) => options.find((item) => item.id === id)?.name)
              .join(", ")
          )
        }
        MenuProps={MenuProps}
        sx={{
          fontSize: "14px", // Adjusts select box font size
        }}
      >
        {/* Select All Option */}
        <MenuItem value="all" sx={menuItemStyles}>
          <Checkbox checked={isAllSelected} />
          <ListItemText sx={menuItemStyles}>Select All</ListItemText>
        </MenuItem>

        {options.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
            sx={{ ...menuItemStyles, paddingTop: 0, paddingBottom: "4px" }}
          >
            <Checkbox checked={fieldValue.includes(item.id)} />
            <ListItemText sx={menuItemStyles}>
              {`${item.name} / (${item.serial_number})`}
            </ListItemText>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelectDropdown;
